import styled from "styled-components";
import { Container, Navbar } from "react-bootstrap";

type OpenElement = {
  openElement?: boolean;
};

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const NavLogo = styled.div`
  padding: 0 55px;
  margin-top: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  width: 100%;
`;

export const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  margin-top: 25px;
`;

export const MenuItem = styled.div`
  height: 36px;
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover {
    border-width: 0px;
    border-left-width: 3px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.green};
    font-family: "Mangueira bold";
  }
  transition: 0.5s border-color;
`;

export const MenuItemLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const MenuItemText = styled.span`
  font-size: 15px;
  color: #fff;
  margin-left: 16px;
`;

export const SocialContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px 30px 50px;
  flex-direction: row;

  a + a {
    margin-left: 12px;
  }
`;

export const SocialIcon = styled.a`
  color: #fff;
  text-decoration: none !important;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &:hover {
    filter: brightness(0.7);
  }

  transition: 0.5s color;

  img {
    width: 25px;
    height: 25px;
  }
`;

export const ContentMenuBurger = styled.div`
  & svg {
    color: #fff;
    font-size: 25px;
  }
`;

export const NavContainer = styled(Container)`
  width: 100%;
  height: 100%;
`;

export const Content = styled.nav`
  background-color: ${({ theme }) => theme.colors.blue};
  width: 100%;
  display: flex !important;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  min-height: 100vh;

  .align-item-menu {
    color: #fff;
    margin-left: 28px;
    width: 24px;
    transition: 1s all;
  }
`;

export const AccessibilityReadOnly = styled.span`
  display: none;
  visibility: hidden;
`;

export const UserContainer = styled.div`
  width: calc(100% - 32px);
  display: flex;
  flex-direction: row;
  margin: 0px 15px 0px 17px;
  padding-top: 30px;
`;

export const UserAvatar = styled.div`
  height: 50px;
  width: 50px;
  padding: 5px 5px;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ theme }) => theme.colors.lightGreen};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.lightBlue};
`;

export const UserInitial = styled.span`
  font-size: 30px;
  color: #fff;
  margin-top: 6px;
`;

export const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 10px 0px 14px;
  justify-content: center;
`;

export const UserName = styled.span`
  font-size: 15px;
  color: #fff;
  font-family: "Mangueira bold";
  font-family: "Mangueira";
`;

export const UserLevel = styled.span`
  font-size: 11px;
  color: #feea9b;
`;

export const CompanyContainer = styled.div`
  display: flex;
  background: #fff;
  width: calc(100% - 32px);
  margin: 20px 15px 0px 17px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const CompanyText = styled.span`
  font-size: 12px;
  color: white;
  padding: 12px 10px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const NavbarComponent = styled(Navbar)`
  background-color: #fff;
  display: none;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 19px 20px;

  @media (max-width: 1100px) {
    display: flex;
    width: 100%;
    position: fixed;
    margin-bottom: 40px;
  }
`;

export const IconMenu = styled.div`
  & svg {
    color: ${({ theme }) => theme?.colors?.blue};
    font-size: 25px;
  }
`;

export const DivOuterContainer = styled.div`
  background-color: #f5f5f5;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar {
    width: 0.1px;
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background: #ffffff;
  }
`;

export const ContentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const BoxTwoBars = styled.div<OpenElement>`
  display: ${({ openElement }) => (openElement ? "none" : "flex")};
  flex-direction: row;
`;

export const BoxNameAddress = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira bold";
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;

export const BoxAddress = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
`;

export const Address = styled.div`
  font-size: 12px;
  color: #818181;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;

export const TwoBars = styled.div`
  color: ${({ theme }) => theme.colors.blueClean};
  font-size: 16px;
  font-family: "Mangueira bold";
  margin-right: 5px;
`;

export const ContentSearch = styled.div<OpenElement>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ openElement }) => (openElement ? "200px" : "30px")};
  height: 30px;
  background-color: #efefef;
  border-radius: 16px;
  position: relative;
  margin-right: 10px;

  & svg {
    font-size: 20px;
    color: ${({ theme }) => theme?.colors?.primaryText};
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 5px;
  }
`;

export const InputSearch = styled.input<OpenElement>`
  width: 100%;
  height: 18px;
  font-size: 14px;
  padding-left: 30px;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${({ theme }) => theme?.colors?.primaryText};
  display: ${({ openElement }) => (openElement ? "block" : "none")};
`;
